import { useEffect } from "react";
import { PageHero } from "@/components/PageHero";
import { Stats } from "@/pages/home/Stats";
import { WhyChoose } from "@/pages/home/WhyChoose";
import { ProcessSteps } from "@/components/ProcessSteps";
import { FinalCta } from "@/components/FinalCta";
import { Reveal } from "@/lib/motion";
import { BUSINESS } from "@/data/site";

const OFFICE = "https://images.unsplash.com/photo-1704188646899-4198ab26341c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBtaW5pbWFsJTIwb2ZmaWNlJTIwYmxhY2t8ZW58MHx8fHwxNzgzNjI0MTExfDA&ixlib=rb-4.1.0&q=85";

export default function About() {
  useEffect(() => { document.title = `About — ${BUSINESS.name}`; }, []);
  return (
    <>
      <PageHero
        overline="About"
        titleLines={["A digital studio", "built to make you", "grow faster."]}
        subtitle={`${BUSINESS.name} is a full-service digital agency helping businesses across ${BUSINESS.serviceArea} launch premium, high-converting websites — blending world-class design, clean engineering and practical AI.`}
      />

      <section className="relative pb-16">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-12 items-center">
          <Reveal className="overflow-hidden rounded-3xl border border-border shadow-sm">
            <img src={OFFICE} alt="Modern minimal studio workspace" loading="lazy"
              className="w-full h-[420px] object-cover" />
          </Reveal>
          <div>
            <Reveal>
              <h2 className="text-3xl md:text-4xl font-heading font-bold tracking-tight">Design that performs, not just impresses</h2>
            </Reveal>
            <Reveal delay={0.08} className="mt-5 space-y-4 text-muted-foreground text-lg leading-relaxed">
              <p>We started {BUSINESS.name} with a simple belief: a website should be a growth engine, not a brochure. Every project is engineered to load fast, rank on Google and turn visitors into customers.</p>
              <p>From our base in Pune, we work with founders and operators across India and the USA — shipping premium websites, SEO systems, AI automations and paid-ad campaigns under one accountable roof.</p>
              <p>No bloated retainers, no endless delays. Just clear communication, honest timelines and work we're genuinely proud to attach our name to.</p>
            </Reveal>
          </div>
        </div>
      </section>

      <Stats />
      <WhyChoose />
      <ProcessSteps />
      <FinalCta />
    </>
  );
}
